// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-stepper[data-v-62d6fb2e] .v-stepper__header {\r\n  height: 0 !important;\n}\n.v-stepper[data-v-62d6fb2e] .v-stepper__step {\r\n  padding-block: 0.5rem !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
